import {
  IdynamicFormItem, IDynamicFormPayload, IBasicFormItem, IDynamicFormItemTooltipPattern,
  IDynamicFormItemTooltipWidget, IconfigItem,
} from '../interfaces/IdynamicFormItem';
import { ITEMS_TYPES, LABEL_TEMPLATE_TYPES } from '../constants/ItemsTypes';
import { IoptionElemet } from '../../interfaces/IoptionElemet';
import { contextMenuTypes } from '../../constants/context-menu-types.enum';
import { InfoBox } from '../interfaces/InfoBox';
import { IReflect } from '../interfaces/reflect.interface';
import { FormReflect } from './form-reflect.class';
import { IConditionalItem } from '@ispm/shared/classes/conditional-item.class';
import { VALUE_TYPES } from '@ispm/dynamic-form/constants/value-type.enum';
/**
 * Created by 310293471 on 14/03/2018.
 */
export class DynamicFormItem implements IdynamicFormItem {
  public id: string;
  infoBoxCss?: string;
  fieldsToPreserve?: string[] | '*';
  contextMenuType?: contextMenuTypes;
  forceEnable?: boolean;
  storageName?: string;
  maxFileSize?: number;
  accept?: string;
  fileButtonText?: string;
  useFriendlyName?: boolean;
  checksumAlgorithm?: string;
  fileExtension?: string;
  processorType?: string;
  public label: string;
  public labelExt: {
    prefix: string,
    templateType: LABEL_TEMPLATE_TYPES,
    payload: [{
      linkTemplate: string,
      text: string
    }]
  };
  public placeholder: string;
  public options: {
    resource?: string | null;
    values?: Array<IoptionElemet|string> | null;
    excludeValue?: string;
    component?:string;
    pathToValues?: string;
    pathToSourceValue?: string; // the path to the value which should be store under the property
    excludeClicksOn?: string; // Additional selectors that the outside click directive should check for
    checkClicksOn?: string; // Selectors that will override the excluded items that outside click checks for
    forceUpdate?: boolean; // Should this item be updated regullary without checking for value changes or validity checks
    encodeQueryParam?: boolean// Should encode query param before sending to backend , Useful for special characters such as +
    autoSelect?: boolean;// set if to automatically select the first option in the options list
  } = { };
  public attributes: { [prop: string]: string | number | boolean};
  public name: string;
  public defaultValue: { 'class': string, 'value': string} | string | null;
  public type: ITEMS_TYPES | string;
  public required: boolean;
  public requiredForPublish: boolean; //came along with the 'required' attribute for visual indication of the mandatory form's field, but will be enforced for the 'publish' action only.
  public regex: string | null;
  public tooltip: null | string;
  public tooltipConfiguration?: IDynamicFormItemTooltipPattern | IDynamicFormItemTooltipWidget;
  public editable ?: boolean;
  public disabled: boolean;
  public fieldsToDisplay?: Array<string | {
    path?: string,
    pattern?: string,
    source?: string,
    display: string,
    conditions?: Array<IConditionalItem>
  }> = [];
  public labelInfo?: Array<InfoBox>;
  public valueInfo?: Array<InfoBox>;
  public cssClass?: string;
  public fieldTemplate?: string;
  public pathToField: string;
  public showAsLink?: boolean;
  public linkPrefix?: string;
  public showLinkSuffix?: boolean;
  public dependedProperties: Array<{
    dataSourcePath: any,
    target: string
  }> = [];
  public reflects: IReflect[] = [];
  public skipFileExtValidation?: boolean;
  public widgetPayload?: IDynamicFormPayload & { [prop: string]: any };
  public configIds: Array<IconfigItem | string>; // Will have ids of configBindings stored in form

  dependOn?: { sourcePath: string; sourceProperty: string; }[];
  valueType: VALUE_TYPES;

  constructor(label: string, name: string, type: ITEMS_TYPES|string, id?: string) {
    this.label = label;
    this.name = name;
    this.id = id || this.name;
    if(type) {
      this.setType(type);
    }
  }

  public setRequired(required: boolean): DynamicFormItem {
    this.required = required;
    return this;
  }

  public setEditable(isEditable: boolean) {
    this.editable = isEditable;
    return this;
  }

  public setOptions(options: string|Array<IoptionElemet|string>,excludeValue?: string):DynamicFormItem {
    if (Array.isArray(options)) {
      this.options.values = options as Array<IoptionElemet | string>;
    } else {
      this.options.resource = options;
    }
    if(excludeValue){
      this.options.excludeValue = excludeValue;
    }
    return this;
  }

  public setComponentToLoad(componentName: string | any): DynamicFormItem {
    this.options.component = componentName;
    return this;
  }

  public setPathToSourceValue(pathToSourceValue: string): DynamicFormItem {
    this.options.pathToSourceValue = pathToSourceValue;
    return this;
  }

  public setAttributes(attributes: { [prop: string]: boolean | string | number}): DynamicFormItem {
    this.attributes = Object.assign({ }, this.attributes, attributes);
    return this;
  }

  public setRegex(regex: string): DynamicFormItem {
    this.regex = regex;
    return this;
  }

  public setDefault(defaultVal: any= null): DynamicFormItem {
    this.defaultValue = defaultVal;
    return this;
  }

  public setDependedProperties(target: string, dataSourcePath: string= null) {
    this.dependedProperties.push({ target, dataSourcePath});
    return this;
  }

  public addReflects(...reflects: Array<FormReflect>) {
    this.reflects.push.apply(this.reflects, reflects);
    return this;
  }

  public static builder(label: string, name: string, type: ITEMS_TYPES|string, id?: string){
    return new DynamicFormItem(label, name, type, id);
  }

  public static from(keys: IBasicFormItem & IdynamicFormItem | {}): DynamicFormItem {
    let item = new DynamicFormItem(null, null, null);
    item = Object.assign(item, keys);
    if ((<IBasicFormItem>keys).type) {
      item.setType((<IBasicFormItem>keys).type);
    }
    return item;
  }

  setType(type: ITEMS_TYPES | string) {
    this.type = type ? ITEMS_TYPES[type.toUpperCase()]: null;
    return this;
  }

  setPathToValues(pathToValues: string) {
    this.options.pathToValues = pathToValues;
    return this;
  }

  addFieldsToDisplay(...fieldsToDisplay: Array<string | { 'path'?: string, 'source'?: string, 'pattern'?: string, 'display': string, conditions?: IConditionalItem[] }>) {
    if (!Array.isArray(this.fieldsToDisplay)) {
        this.fieldsToDisplay = [];
    }
    this.fieldsToDisplay.push.apply(this.fieldsToDisplay, fieldsToDisplay);
    return this;
  }

  setFieldTemplate(value: string ) {
    this.fieldTemplate = value;
    return this;
  }

  setPlaceholder(value: string ) {
    this.placeholder = value;
    return this;
  }



  setCssClass(cssClass: string) {
    this.cssClass = cssClass;
    return this;
  }

  setWidgetPayload(widgetPayload: any) {
    this.widgetPayload = widgetPayload;
    return this;
  }

  setCheckClicksOn(selectors: string) {
      if (!this.options) {
        this.options = { };
      }
      this.options.checkClicksOn = selectors;
      return this;
  }
  setValueType(valueType: VALUE_TYPES) {
    this.valueType = valueType;
    return this;
  }

}
